<pos-app-spinner> </pos-app-spinner>
<div class="container-fluid py-2" *ngIf="{ values: lookupLists$ | async } as lookupLists">
  <form [formGroup]="updatePartnerProgramme">
    <div class="text-center">
      <h3 class="pt-3 arb-large-heading">MANAGE PARTNERS PROGRAMMES</h3>
    </div>
    <div *ngIf="!isAddingNewPartnerProgramme" class="card shadow-sm mt-4">
      <div class="card-body">
        <div class="row pb-4">
          <div class="col-8">
            <div class="col-6">
              <label for="'partnerProgramme'">PARTNER PROGRAMME</label>
              <ng-select formControlName="partnerProgramme">
                <ng-option
                  *ngFor="let partnerProgramme of lookupLists.values?.partnerProgrammeList"
                  [value]="partnerProgramme.programmeCode"
                  [disabled]="isAddingNewPartnerProgramme"
                >
                  <span class="pe-1" *ngIf="partnerProgramme.Code">{{ partnerProgramme.programmeCode }} -</span>
                  {{ partnerProgramme.programmeName }}
                </ng-option>
              </ng-select>
            </div>
          </div>

          <div class="col-4 d-flex float-end justify-content-end">
            <div class="m-2">
              <button class="btn btn-secondary" type="button" (click)="addNewPartnerProgramme()">ADD NEW PROGRAMME</button>
            </div>
            <div class="m-2">
              <button class="btn btn-secondary" type="button" (click)="navigateTo('/pos/partner/manage')">MANAGE PARTNERS</button>
            </div>
          </div>

          <!-- ADD MAINTAIN PARTNER PROGRAMMES HERE -->
        </div>
      </div>
    </div>
    <div class="card shadow-sm mt-4" *ngIf="updatePartnerProgramme.get('partnerProgramme').value || isAddingNewPartnerProgramme">
      <div class="card-body">
        <h4 class="text-center">
          <label>{{ isAddingNewPartnerProgramme ? 'ADD NEW PROGRAMME' : 'UPDATE PROGRAMME' }} </label>
        </h4>
        <div class="row">
          <div class="col-9 row">
            <div class="col-5">
              <div class="col my-auto">
                <label for="program_code"
                  >PROGRAMME CODE* <span *ngIf="existingProgrammeCode" class="text-danger">(Programme code already exist)</span></label
                >
              </div>
              <div class="col my-auto form-control-wrapper">
                <input
                  type="text"
                  class="form-control"
                  [readOnly]="!isAddingNewPartnerProgramme"
                  formControlName="programmeCode"
                  maxlength="10"
                  [ngClass]="{
                    'is-invalid':
                      updatePartnerProgramme.get('programmeCode').invalid &&
                      (updatePartnerProgramme.get('programmeCode').dirty || updatePartnerProgramme.get('programmeCode').touched)
                  }"
                />
                <span class="invalid-tooltip hover-tooltip">Programme code required</span>
              </div>
            </div>
            <div class="col-5">
              <div class="col my-auto">
                <label for="program_name">PROGRAMME NAME* </label>
              </div>
              <div class="col my-auto form-control-wrapper">
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{
                    'is-invalid':
                      updatePartnerProgramme.get('programmeName').invalid &&
                      (updatePartnerProgramme.get('programmeName').dirty || updatePartnerProgramme.get('programmeName').touched)
                  }"
                  formControlName="programmeName"
                  maxlength="30"
                />
                <span class="invalid-tooltip hover-tooltip">Programme name required</span>
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="start_date"> EFFECTIVE DATE*</label>
              </div>
              <div class="col my-auto">
                <div class="input-group">
                  <input
                    class="form-control"
                    [ngClass]="{
                      'is-invalid':
                        updatePartnerProgramme.get('effectiveDate').invalid &&
                        (updatePartnerProgramme.get('effectiveDate').dirty || updatePartnerProgramme.get('effectiveDate').touched)
                    }"
                    name="d1"
                    ngbDatepicker
                    #d1="ngbDatepicker"
                    [placement]="'bottom'"
                    container="body"
                    formControlName="effectiveDate"
                    (click)="d1.toggle()"
                    readonly
                  />
                  <div class="input-group-append">
                    <button class="btn btn-secondary calendar text-white btn-picker" (click)="d1.toggle()" type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="end_date"> EXPIRY DATE*</label>
              </div>
              <div class="col my-auto">
                <div class="input-group">
                  <input
                    class="form-control"
                    [ngClass]="{
                      'is-invalid':
                        updatePartnerProgramme.get('expiryDate').invalid &&
                        (updatePartnerProgramme.get('expiryDate').dirty || updatePartnerProgramme.get('expiryDate').touched)
                    }"
                    name="d2"
                    ngbDatepicker
                    #d2="ngbDatepicker"
                    [placement]="'bottom'"
                    container="body"
                    formControlName="expiryDate"
                    (click)="d2.toggle()"
                    readonly
                  />
                  <div class="input-group-append">
                    <button class="btn btn-secondary calendar text-white btn-picker" (click)="d2.toggle()" type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="override_customer"> OVERRIDE BILL TO CUSTOMER</label>
              </div>
              <pos-app-lib-customer-search
                [customerType]="'billto'"
                (selectNewCustomer)="selectCustomer($event)"
                [selectedCustomerName]="updatePartnerProgramme.get('overrideCustomerNumber').value"
                [disabled]="false"
                [showSearchIcon]="true"
                placeHolder="CUSTOMER SEARCH"
                value="{{ preOverrideCustomerNumber }}"
                [removeCustomerAfterLoad]="removeCustomerAfterLoad"
              ></pos-app-lib-customer-search>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="vehicle_make"> FILTER VEHICLES BY MAKE</label>
              </div>
              <div class="col my-auto">
                <select class="form-select" formControlName="filterVehicleMake">
                  <option *ngFor="let make of vehicleListMake" [value]="make">
                    {{ make }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="menu_filter_category"> PRODUCT MENU FILTER CATEGORY</label>
              </div>
              <div class="col my-auto">
                <input type="text" class="form-control" formControlName="menuFilterCategory" />
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="order_Types">VALID ORDER TYPES </label>
              </div>
              <div class="col my-auto">
                <ng-select
                  formControlName="validOrderTypes"
                  [items]="lookupLists.values?.orderTypeList"
                  [multiple]="true"
                  bindLabel="OrderTypeDescription"
                  bindValue="OrderTypeCode"
                  [searchable]="true"
                >
                </ng-select>
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="generic_Quote_Customer_Number"> GENERIC QUOTE CUSTOMER</label>
              </div>
              <pos-app-lib-customer-search
                (selectNewCustomer)="selectCustomer($event)"
                [selectedCustomerName]="updatePartnerProgramme.get('genericQuoteCustomerNumber').value"
                [disabled]="false"
                [showSearchIcon]="true"
                placeHolder="CUSTOMER SEARCH"
                value="{{ preGenericQuoteCustomerNumber }}"
                [removeCustomerAfterLoad]="removeCustomerAfterLoad"
              ></pos-app-lib-customer-search>
            </div>
            <div class="col-5 mt-2">
              <div class="col my-auto">
                <label for="generic_Quote_Customer_Number"> CUSTOM PRICING</label>
              </div>

              <div class="col my-auto form-control-wrapper">
                <input type="text" class="form-control" formControlName="customPricingFunction" maxlength="10" />
              </div>
            </div>
            <div class="col-10 mt-2">
              <div class="col my-auto">
                <label for="help_message"> HELP MESSAGE (HTML)</label>
              </div>
              <input type="text" class="form-control" formControlName="helpMessage" />
            </div>
          </div>
          <div class="col-3">
            <div class="row mb-2">
              <div *ngIf="!isAddingNewPartnerProgramme" class="col-12 col-sm-6 mb-2 mb-sm-0">
                <button
                  class="btn btn-secondary w-100"
                  [disabled]="formValid || !updatePartnerProgramme.controls.partnerProgramme.value"
                  type="button"
                  (click)="openEnrollToProgram()"
                >
                  ENROLLED PARTNER
                </button>
              </div>
            </div>
            <label>SETTINGS</label>
            <div class="">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="defaultCustomerXrefTF"
                [checked]="updatePartnerProgramme.get('defaultCustomerXrefTF').value"
              />
              <label class="ps-2">DEFAULT X-REF PARTS</label>
            </div>
            <div class="">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="hideBuyPriceTF"
                [checked]="updatePartnerProgramme.get('hideBuyPriceTF').value"
              />
              <label class="ps-2">HIDE BUY PRICE</label>
            </div>
            <div class="">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="saveQuotesTF"
                [checked]="updatePartnerProgramme.get('saveQuotesTF').value"
              />
              <label class="ps-2">SAVE QUOTES</label>
            </div>
            <div class="">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="genericQuotesOnlyTF"
                [checked]="updatePartnerProgramme.get('genericQuotesOnlyTF').value"
              />
              <label class="ps-2">GENERIC QUOTES ONLY</label>
            </div>
          </div>
        </div>

        <div class="col-2 mt-2 d-flex float-end justify-content-end">
          <button class="btn btn-reset mx-1 px-2" *ngIf="formValid" (click)="resetFormSelectedProgram()">RESET</button>
          <button class="btn btn-cancel mx-1 px-2" (click)="cancel()">CANCEL</button>
          <button class="btn text-white mx-1 px-2" (click)="save()" [disabled]="!updatePartnerProgramme.valid || !formValid">SAVE</button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">
      {{ isEnrollPartnerToProgram ? 'ENROLL PARTNER' : '' }}
    </h3>
  </div>
  <div class="modal-body">
    <div *ngIf="isEnrollPartnerToProgram">
      <app-manage-partner-enrollment
        [partnerProgrammeCode]="updatePartnerProgramme.get('partnerProgramme').value"
        [partnerProgrammeName]="updatePartnerProgramme.get('programmeName').value"
        (closeModal)="handleCloseModal()"
      >
      </app-manage-partner-enrollment>

      <div class="d-flex float-end">
        <button class="btn btn-cancel m-2" (click)="handleCloseModal()">CANCEL</button>
      </div>
    </div>
  </div>
</ng-template>
